import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/delivery.scss";

const deliveryRegions = [
  ["Hong Kong", "1–3 business days"],
  ["Mainland China", "2–5 business days"],
  ["Asia Pacific", "3–7 business days"],
  ["United Kingdom and wider Europe", "3–7 business days"],
  ["United States and Canada", "4–8 business days"],
  ["Other available destinations", "6–12 business days"],
];

function Delivery() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const standardCost = formatPrice(siteConfig.shipping.standard);

  return (
    <main className="policy-page delivery">
      <header className="policy-page__hero">
        <div>
          <p className="policy-page__kicker">Client care / Delivery</p>
          <h1>Shipping information</h1>
        </div>
        <div className="policy-page__intro">
          <p>
            Orders are carefully checked and prepared within 2–5 business days.
            Transit estimates begin once the parcel leaves our facility.
          </p>
          <span>Tracked delivery / Available regions shown at checkout</span>
        </div>
      </header>

      <div className="policy-page__layout delivery__layout">
        <aside className="policy-page__aside">
          <p className="policy-page__kicker">Delivery summary</p>
          <dl className="delivery__facts">
            <div><dt>Preparation</dt><dd>2–5 business days</dd></div>
            <div><dt>Standard delivery</dt><dd>{standardCost}</dd></div>
            <div><dt>Dispatch point</dt><dd>Hong Kong</dd></div>
          </dl>
        </aside>

        <article className="policy-page__content">
          <section className="delivery__notice">
            <p className="policy-page__section-number">01</p>
            <h2>Preparation and dispatch</h2>
            <p>
              We normally prepare in-stock orders within 2–5 business days,
              excluding weekends and local public holidays. Verification, launch
              periods or unusually high volume may extend this stage. You will
              receive a dispatch email with tracking when the carrier accepts the
              parcel.
            </p>
            <p>
              Orders containing multiple items may be sent in separate parcels.
              There is no additional standard delivery charge when we choose to
              split an order.
            </p>
          </section>

          <section>
            <p className="policy-page__section-number">02</p>
            <h2>Delivery rate</h2>
            <p>
              Tracked standard delivery is a flat {standardCost} per order. The
              checkout shows the available destination and final order total
              before you continue to the secure payment page.
            </p>
            <p>
              Delivery is offered only to the destinations listed at checkout.
              Restricted and sanctioned destinations are excluded, and we may
              decline an address that a carrier or payment provider cannot serve.
            </p>
          </section>

          <section aria-labelledby="delivery-estimates">
            <p className="policy-page__section-number">03</p>
            <h2 id="delivery-estimates">Estimated transit after dispatch</h2>
            <div className="delivery__table-wrap">
              <table className="delivery__table">
                <thead><tr><th>Destination</th><th>Estimated transit</th></tr></thead>
                <tbody>
                  {deliveryRegions.map(([region, estimate]) => (
                    <tr key={region}><td>{region}</td><td>{estimate}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="delivery__fine-print">
              Estimates are guidance, not guaranteed dates. Customs review,
              weather, carrier disruption and local delivery conditions can add time.
            </p>
          </section>

          <section>
            <p className="policy-page__section-number">04</p>
            <h2>Addresses, tracking and receipt</h2>
            <p>
              Enter a complete address and any access
              details at checkout. Contact us immediately if something is wrong;
              an address cannot always be changed after dispatch. We cannot ship
              to every PO box, forwarding service or restricted destination.
            </p>
            <p>
              Follow the carrier link for current tracking. A signature or secure
              delivery method may be required. If tracking says delivered but the
              parcel is missing, check safe places and neighbours before contacting
              the carrier and our client-care team.
            </p>
          </section>

          <section>
            <p className="policy-page__section-number">05</p>
            <h2>Taxes and destination requirements</h2>
            <p>
              Checkout displays the order total collected by us. Local authorities
              or carriers may apply destination-specific taxes, handling rules or
              identity checks that are outside our control and are not part of the
              standard delivery charge.
            </p>
            <p>
              Refusing a parcel after dispatch may create return, storage or
              carrier costs. Where law permits, those costs can be deducted from
              the refund after the parcel safely returns to our Hong Kong facility.
            </p>
          </section>

          <section>
            <p className="policy-page__section-number">06</p>
            <h2>Delays and damaged parcels</h2>
            <p>
              If tracking stops updating beyond the estimate, contact us with the
              order number so we can open a carrier enquiry. For a visibly damaged
              parcel, photograph the outer packaging and contents and notify us as
              soon as practical. Keep all packaging while the claim is reviewed.
            </p>
          </section>

          <nav className="policy-page__related" aria-label="Delivery support links">
            <Link to="/returns" onClick={toTop}>Read the returns policy</Link>
            <Link to="/contact" onClick={toTop}>Contact client care</Link>
            <Link to="/terms" onClick={toTop}>Terms and conditions</Link>
          </nav>
        </article>
      </div>
    </main>
  );
}

export default Delivery;
